import * as React from "react";
import FullScreenModal from "@/features/shell/components/FullScreenModal/FullScreenModal";
import { useShellStore } from "@/features/shell/stores/shellStore";
import { Typography } from "@picklebet/ui";
import { SupportLink } from "@/features/shell/components/shared/SupportLink";
import { Link } from "@/features/shell/components/shared/Link/Link";

export const BET_STOP_MODAL_ID_SIGNUP = "BetStopSignup";

export const BetStopModalSignup = () => {
  const isOpen = useShellStore(
    (state) => state.modal === BET_STOP_MODAL_ID_SIGNUP,
  );
  const setModal = useShellStore((state) => state.setModal);

  const handleClose = () => {
    setModal(null);
  };

  return (
    <FullScreenModal
      isOpen={isOpen}
      onClose={handleClose}
      title={"National Self-Exclusion Register"}
    >
      <Typography variant="body">
        Due to your details appearing on the BetStop National Self-Exclusion
        Register, you are prevented from creating a betting account with
        Picklebet. More information on Gambling help can be found in our{" "}
        <SupportLink
          options={{ labels: ["weblink-responsible-gambling-policy"] }}
          hideChevron
        >
          Responsible Gambling Policy.
        </SupportLink>
      </Typography>

      <Typography variant="body">
        Customer Support and our Safer Gambling Team can also assist you with
        any of these options via{" "}
        <Link to="mailto:support@picklebet.com">email</Link> and{" "}
        <Link to="https://live-chat"> Live Chat</Link> .
      </Typography>
    </FullScreenModal>
  );
};
